export default {
  isEligible: function (_isEligible = false) {
    return _isEligible
  },

  getEvents: function () {
    return {
      EARLY_ACCESS_ELIGIBILITY_CHANGED: 'earlyAccessEligiblility',
    }
  },

  getEligibleTooltip(_eligibleTooltip = false) {
    return _eligibleTooltip
  },

  getInvitationTooltip(_invitationTooltip = false) {
    return _invitationTooltip
  },
}
